
import { parseToken, buildObjectProperty, convertRgbHex, getTokenPlanner, setCookie, getCookie, convertRgb,getTokenCookie,assetUrl, getCartCookie } from '../utils/Common'
import axiosInstance from '../utils/axiosInstance.js'
import { API_URL, ESHOW_URL, main_widow_offset_x, main_widow_offset_y  } from '../config.js'

export const saveLog = async (postData)=>{
    const options = {
        headers: {
            'body': '[{"company:","test"}]', 
            'Content-Type': 'application/json'
          }
    }
    var url = `${ESHOW_URL()}?method=putAuditLog&token=${getTokenCookie()}`
    try {
        var response = await axiosInstance.post(url, JSON.stringify(postData), options)
        if(response.status == 200 && response.data?.SUCCESS !== false){
            return { success: true }
        }
        console.error('[AuditLog] saveLog failed:', response.data)
        return { success: false, error: response.data?.MESSAGE || 'Unknown error' }
    } catch (error) {
        console.error('[AuditLog] saveLog error:', error)
        return { success: false, error: error.message }
    }
}

export const fetchCategoryOptions =async ()=>{
    try {
        var url = `${ESHOW_URL()}?method=getProductCategories&token=${getTokenCookie()}` 
        var response = await axiosInstance.get(url);

        const result = response.data;
        if(result.SUCCESS){  
            if(result.CATEGORIES){        
                var data = result.CATEGORIES
                data.sort(function (a, b) {
                    return (a.DISPLAY_ORDER?a.DISPLAY_ORDER:0)*1 - (b.DISPLAY_ORDER?b.DISPLAY_ORDER:0)*1;
                });          
                return data;
            }
        }
        else {
            throw new Error("Failed to fetch categories");
        }
    } catch (error) {
        throw error;
    }
}  

export const fetchPricingOptions =async ()=>{
    var url = `${ESHOW_URL()}?method=getSales&product_type=sales&token=${getTokenCookie()}` 
    var response = await axiosInstance.get(url);

    const result = response.data;
    if(result.SUCCESS){  
        if(result.SUCCESS){  
            if(result.SALES){     
              let data = result.SALES
              data.sort(function (a, b) {
                  return (a.DISPLAY_ORDER?a.DISPLAY_ORDER:0)*1 - (b.DISPLAY_ORDER?b.DISPLAY_ORDER:0)*1;
              });   
              return data
            }
        }
    }
    else {
        throw new Error("Failed to fetch categories");
    }

  }

export const getExhibitorList =async (props, map_key)=>{
    var token = getTokenCookie();   
    if(props.main.authInfo?.role != 'admin') {
        try{     
            var _token = getTokenPlanner();
            if(_token){
            token = _token
            }
        }
        catch(e){
        console.log("token parse", e)
        }
    }
    else{
    }

    var url = `${ESHOW_URL()}?method=getExhibitorList&token=${token}${map_key?('&map_key='+map_key):''}`
    var response = await axiosInstance.get(url);

    const result = response.data;
    if(result.SUCCESS){  
        if(result.SUCCESS){  
            if(result.EXHIBITORS){     
              let data = result.EXHIBITORS
              return data
            }
        }
    }
    else {
        throw new Error("Failed to fetch categories");
    }

  }